import { createContext, useContext } from "react";
import type { Workspace } from "../api/types";
import { can, type Permission } from "../lib/permissions";

export const WorkspaceContext = createContext<Workspace | null>(null);

export function useWorkspace(): Workspace {
  const ws = useContext(WorkspaceContext);
  if (!ws) throw new Error("useWorkspace fora de um workspace");
  return ws;
}

export function useCan(permission: Permission): boolean {
  return can(useWorkspace().role, permission);
}

export const LAST_WORKSPACE_KEY = "pf:lastWorkspace";

export function rememberWorkspace(id: string) {
  try {
    localStorage.setItem(LAST_WORKSPACE_KEY, id);
  } catch {
    /* storage indisponível: só perde a conveniência */
  }
}

export function lastWorkspace(): string | null {
  try {
    return localStorage.getItem(LAST_WORKSPACE_KEY);
  } catch {
    return null;
  }
}
